import { uniq } from "lodash";
import * as React from "react";
import { DatePicker } from "../../../../../../react-core/Datepicker/DatePicker";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CustomerNameFuzzySearchClient } from "../../../../../../Wrap/Api/Customer/CustomerNameFuzzySearch";
import { AccountRoleActorCategory } from "../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { PhysicalAddressType } from "../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { AccountRoleType } from "../../../../../../Wrap/Models/Domains/Customers/AccountRoleType";
import { FullClientDetailModel } from "../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { CheckboxGroup } from "../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { ACCEPT_DATE_FORMATS, ContentDatePicker } from "../../../../../Shared/Entities/Constants/DateConstants";
import { TitleMap } from "../../../../../Shared/Entities/Maps/TitleMap";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { SearchInput } from "../../../../../Shared/SearchInput/SearchInput";
import { Table } from "../../../../../Shared/Table/Table";
import { setValueByKey } from "../../../../../Shared/Table/Utils/TableUtils";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { validationMessage } from "../../AddClient/Resource/Validation";
import { ClientRecordAction } from "../../ClientRecord/Action/ClientRecordAction";
import { roleTypeMap } from "../../ClientRecord/Resource/Contents";
import { PhoneNumberDetails } from "../../Common/ClientDetails/PhoneNumberDetails";
import { NewBusinessAction } from "../../NewBusinessWizard/Actions/NewBusinessAction";
import { AddAddress } from "../../NewBusinessWizard/Components/FullClientDetail/AddAddress";
import { CustomerContextStoreStatic } from "../../NewBusinessWizard/Stores/Variable";
import { portfolioDashboardRolesAction } from "../../PortfolioDashboard/Components/Role/Action/Action";
import { PortfolioDashboardStore } from "../../PortfolioDashboard/Store/Variable";
import { AccountInfoAction } from "../../PortfolioDashboard/Components/Role/Action/AccountInfoAction";
import {
    ControllingPersonTypeArray,
    ControllingPersonTypeMap,
    InterestedPartySteppers,
} from "../../PortfolioDashboard/Components/Role/Resource/Contents";
import { hasClientPortalAccess, isDisplay } from "./InterestedPartyHelper";
import { Nationality } from "../../NewBusinessWizard/Components/FullClientDetail/Nationality";
import { CustomerTaxResidencyModel } from "../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { CountryCodeMap } from "../../../../../Shared/Entities/Maps/CountryCodeMap";
import { CountryCode } from "../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { TaxDetail } from "../../NewBusinessWizard/Components/FullClientDetail/TaxDetail";
import { FullClientDetailHelper } from "../../Common/FullClientDetail/FullClientDetailHelper";
import { AddAddresses } from "../../NewBusinessWizard/Components/FullClientDetail/Addresses";
import { PermissionAction } from "../../../../../Shared/Permission/Action/PermissionAction";
import { ControllingPersonType } from "../../../../../../Wrap/Constants/Enums/Customer/ControllingPersonType";

interface IClientDetailsProps extends IProcessComponentProps {
    existingCustomer?:boolean;
}

export interface IClientDetailsState {
    roleSelected: AccountRoleType;
    isCreateNewCustomer: boolean;
    clientPortalAccess: boolean;
    customerSelected: FullClientDetailModel;
    adviserId: number;
    UseAddressForCorrespondence?: boolean;
    availableRoleTypes: AccountRoleType[];
    selectedAccounts: Array<ClientAccount>;
    availableAccounts: Array<ClientAccount>;
    interestedParties: any[];
    residencies: CustomerTaxResidencyModel[];
    nationalities: CustomerTaxResidencyModel[];
    hasNewUserAccess: boolean;
    controllingPersonType: ControllingPersonType;
    hasCorrespondenceAddress: boolean;
}

export class ClientDetails extends ProcessComponent<IClientDetailsProps, IClientDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            roleSelected: null,
            clientPortalAccess: null,
            customerSelected: null,
            isCreateNewCustomer: null,
            adviserId: null,
            UseAddressForCorrespondence: null,
            availableRoleTypes: [],
            selectedAccounts: [],
            availableAccounts: [],
            interestedParties: null,
            residencies: [],
            nationalities: [{ IsNationality: true }],
            hasNewUserAccess: null,
            controllingPersonType: ControllingPersonType.NotSpecified,
            hasCorrespondenceAddress: true,
        };
    }

    public getState() {
        return this.state;
    }

    componentDidMount() {
        PermissionAction.getPermissionForASPXPage("/Admin/Users/NewUser.aspx", (res) => {
            this.setState({ hasNewUserAccess: res.HasPermission });
        });
        const investorType = getQueryParameters()["investortype"];
        const accountHierarchyId = getQueryParameters()["hierarchyid"];
        if (accountHierarchyId) {
            this.setState({ selectedAccounts: [{ HierarchyId: accountHierarchyId }] });
        } else {
            ClientRecordAction.getAccountRoleWithAccountDetails(getQueryParameters()["customerid"], (result) => {
                const accountHolderRoles = result?.AccountRoles?.filter(
                    (x) =>
                        x.AccountRoleType == RoleType.IndividualAccountHolder ||
                        x.AccountRoleType == RoleType.JointAccountHolder ||
                        x.AccountRoleType == RoleType.TrustAccountHolder
                );
                let allAccounts = PortfolioDashboardStore.getData();
                allAccounts = allAccounts.filter((x) =>
                    accountHolderRoles.some((y) => y.ClAccountId == x.HeadClAccountId)
                );

                this.setState({ availableAccounts: allAccounts });
            });
        }
        if (investorType) {
            this.getAvailableRoleTypes([Number(investorType)]);
        }

        NewBusinessAction.getCustomerData(getQueryParameters()["customerid"], (data) => {
            this.setState({ adviserId: data?.ActorOwnerId });
        });
        const actorId = getQueryParameters()["ipid"];
        if (Number(actorId) > 0) {
            NewBusinessAction.getCustomerData(actorId, (data) => {
                this.setState({
                    customerSelected: data,
                    roleSelected: { RoleType: getQueryParameters()["accountrole"] },
                    nationalities: data.CustomerTaxResidencyDetails,
                    residencies: data.CustomerTaxResidencyDetails,
                });
            });
        }
        super.componentDidMount();
    }

    getInterrestedParty() {
        portfolioDashboardRolesAction.getInterestedParties(
            this.state.selectedAccounts.map((a) => a.HierarchyId),
            (res) => {
                this.setState({
                    interestedParties: res,
                });
            }
        );
    }

    isValid() {
        const data = this.state.customerSelected;
        const residentialAddress = data.AddressDetails?.find(
            (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
        );
        const correspondenceAddress = data.AddressDetails?.find(
            (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Postal
        );
        let msg: string[] = [];
        let isRoleExist = false;
        if (
            this.state.roleSelected?.RoleType == RoleType.AccountAccess ||
            this.state.roleSelected?.RoleType == RoleType.PowerOfAttorney
        ) {
            if (this.state.interestedParties) {
                this.state.selectedAccounts.forEach((account) => {
                    if (!isRoleExist) {
                        isRoleExist = this.state.interestedParties?.find(
                            (x) =>
                                x.ActorId == data?.ActorId &&
                                x.AccountRoleType == this.state.roleSelected?.RoleType &&
                                x.HierarchyId == account.HierarchyId
                        );
                    }
                });
                if (isRoleExist) {
                    msg = msg.concat(["one or more account role have already added"]);
                }
            } else {
                if (this.state.selectedAccounts?.length > 0) {
                    portfolioDashboardRolesAction.getInterestedParties(
                        this.state.selectedAccounts?.map((a) => a.HierarchyId),
                        (res) => {
                            this.state.selectedAccounts.forEach((account) => {
                                if (!isRoleExist) {
                                    isRoleExist = res?.find(
                                        (x) =>
                                            x.ActorId == data?.ActorId &&
                                            x.AccountRoleType == this.state.roleSelected?.RoleType &&
                                            x.HierarchyId == account.HierarchyId
                                    );
                                }
                            });
                            if (isRoleExist) {
                                msg = msg.concat(["one or more account role have already added"]);
                            }
                        }
                    );
                }
            }
        }

        if (!residentialAddress) {msg = msg.concat(["You must enter residential address"]);}
        if (!this.state.hasCorrespondenceAddress && !correspondenceAddress) {
            msg = msg.concat(["You must enter correspondence address"]);
        }
        if (msg.length > 0) {
            this.props.showErrorMsgPopUp(msg, true);
            return false;
        }

        return super.isValid();
    }

    private getAvailableRoleTypes(investorTypes: number[], hierarchyIds?: string[]) {
        if (investorTypes.length == 0 && (!hierarchyIds || hierarchyIds.length == 0)) {return;}
        const customer = CustomerContextStoreStatic.getData();
        AccountInfoAction.getAvailableAccountRoleTypes(
            investorTypes,
            customer.ActorId?.toString(),
            hierarchyIds,
            (data) => {
                data = data ? data : [];
                this.setState({ availableRoleTypes: data });
            }
        );
    }

    getRoleDropDown(data: Array<AccountRoleType>) {
        // sort by long name asc
        data = data?.sort((a, b) => {
            if (a?.LongName > b?.LongName) {
                return 1;
            }
            if (a?.LongName < b?.LongName) {
                return -1;
            }
            return 0;
        });
        return uniq(data?.map((e) => e?.RoleType));
    }

    renderCustomerSearch() {
        const client = new CustomerNameFuzzySearchClient();
        return (
            <>
                <h3>Search for customer</h3>
                <SearchInput
                    apiClient={(v) => {
                        return client.get(v, this.state.adviserId, this.state.roleSelected?.RoleType);
                    }}
                    minLength={3}
                    customeChildren={(data) => this.transformInputSearch(data)}
                    cssWrapper="mb-35 control-size-430"
                />
            </>
        );
    }

    private resetUseAddressForCorrespondence() {
        const data = this.state.customerSelected.AddressDetails;
        const index = data?.findIndex((ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential);

        const postalindex = index == 1 ? 0 : 1;
        data.splice(postalindex, 1);
        this.onCCMChange([{ value: data, path: `AddressDetails` }]);
        this.setState({ UseAddressForCorrespondence: false });
    }

    private transformInputSearch(data: any) {
        if (data) {
            const customeChildren = (
                <Table
                    data={data}
                    col={[
                        {
                            title: "Client",
                            key: "Name",
                            render: (data, row, index) => {
                                return <span>{row.FirstName + " " + row.LastName}</span>;
                            },
                        },
                        {
                            title: "Date of birth",
                            key: "DateOfBirth",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDateString(new Date(data), "dd MM yyyy", true);
                            },
                        },
                        {
                            title: "Assigned adviser",
                            key: "OwnerAdviserId",
                        },
                        {
                            title: "",
                            key: "",
                            render: (data, row, index) => {
                                return (
                                    <button className="secondary-add-button" onClick={() => this.addClient(row)}>
                                        <span className="text">+ add client</span>
                                    </button>
                                );
                            },
                        },
                    ]}
                    showEmptyMsg={true}
                />
            );
            return customeChildren;
        }
    }

    private addClient(row: any) {
        NewBusinessAction.getCustomerData(row?.ActorId, (data) => {
            const hasPostalAddress = data.AddressDetails?.find(
                (ele) => ele.PhysicalAddressType == PhysicalAddressType.Postal
            );
            if (!data.ActorUserId) {
                this.setState({ clientPortalAccess: false });
            } else if (data?.ActorUserId > 0) {
                this.setState({ clientPortalAccess: true });
            }
            let initArray = [];
            if (this.state.roleSelected?.RoleType == RoleType.ControllingPerson) {
                if (this.state.roleSelected?.RoleType == RoleType.ControllingPerson) {
                    initArray = FullClientDetailHelper.initTaxModel(initArray, data);
                }
            }
            if (hasPostalAddress) {
                this.setState({ customerSelected: data, UseAddressForCorrespondence: false }, () =>
                    this.onCCMChange(initArray)
                );
            } else {
                this.setState({ customerSelected: data }, () => this.onCCMChange(initArray));
            }
            this.setState({ nationalities: data.CustomerTaxResidencyDetails });
            this.setState({ residencies: data.CustomerTaxResidencyDetails });
        });
    }

    private onCCMChange = (changes: { value: any; path: string }[]) => {
        const { customerSelected } = this.state;
        let _model = { ...customerSelected };
        changes.forEach((change) => {
            _model = setValueByKey(_model, change.path, change.value);
        });
        this.setState({ customerSelected: _model });
    };

    private hasResident(): boolean {
        return this.state.customerSelected.AddressDetails?.some(
            (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
        );
    }

    onCorrespondenceAddressChange(val): void {
        this.setState({ hasCorrespondenceAddress: val });
    }

    private renderClientDetails() {
        const roleType = this.state.roleSelected?.RoleType;
        const data = this.state.customerSelected;
        return (
            <>
                <SelectEditor
                    options={TitleMap.getArray()}
                    cssWrapper="control-size-180"
                    selected={data.PersonalDetails?.Title}
                    label={"Title"}
                    getText={(option) => TitleMap.getString(option)}
                    onChange={(v) => this.onCCMChange([{ value: v, path: "PersonalDetails.Title" }])}
                    placeholder={"Please select"}
                    required={validationMessage.titleValidation}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data.PersonalDetails?.GivenName}
                    label={"First name"}
                    onChange={(v) => this.onCCMChange([{ value: v, path: "PersonalDetails.GivenName" }])}
                    required={validationMessage.firstNameValidation}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data.PersonalDetails?.FamilyName}
                    label={"Surname"}
                    onChange={(v) => this.onCCMChange([{ value: v, path: "PersonalDetails.FamilyName" }])}
                    required={validationMessage.surnameValidation}
                />
                {isDisplay(roleType, "DOB") && (
                    <DatePicker
                        label={"Date of birth"}
                        formGroupCssWrapper={"control-size-430"}
                        selected={JsonDateParser.toDateNoOffset(data?.PersonalDetails?.DateOfBirth)}
                        alwaysValidateOnUpdate={false}
                        atLeast={{
                            value: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                            errorMessage: ContentDatePicker.CannotBeInThePast,
                        }}
                        atMost={{
                            value: roleType === RoleType.RegisteredContact 
                                ? new Date(new Date().setFullYear(new Date().getFullYear() - 18)) 
                                : new Date(), 
                            errorMessage: roleType === RoleType.RegisteredContact 
                                ? "The person must be at least 18 years old"
                                : ContentDatePicker.CannotBeInTheFuture,
                        }}
                        showYearDropdown={true}
                        onChange={(v) => {
                            this.onCCMChange([
                                { value: JsonDateParser.toJsonDateNoOffset(v), path: "PersonalDetails.DateOfBirth" },
                            ]);
                        }}
                        todayButton={ContentDatePicker.Today}
                        isClearable={true}
                        dateFormat={ContentDatePicker.DateFormat}
                        acceptDateFormats={ACCEPT_DATE_FORMATS}
                        required={"Please select a date"}
                    />
                )}
                {isDisplay(roleType, "TOB") && (
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="Town of birth"
                        onChange={(v) => {
                            this.onCCMChange([{ value: v, path: "PersonalDetails.TownOfBirth" }]);
                        }}
                        value={data?.PersonalDetails?.TownOfBirth}
                        maxLength={50}
                    />
                )}
                {isDisplay(roleType, "COB") && (
                    <SelectEditor
                        cssWrapper="control-size-430"
                        options={CountryCodeMap.getArray()}
                        getText={(v) => CountryCodeMap.getString(v)}
                        onChange={(v) => {
                            this.onCCMChange([{ value: v, path: "PersonalDetails.CountryOfBirth" }]);
                        }}
                        selected={data?.PersonalDetails?.CountryOfBirth}
                        label="Country of birth"
                        placeholder="Please select"
                    />
                )}
                {roleType == RoleType.ControllingPerson && (
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        label="Legal name/Corporate name"
                        onChange={(v) => {}}
                        value={this.state.selectedAccounts[0]?.AccountName}
                        maxLength={50}
                        disabled
                    />
                )}
                {/* <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label="Gender"
                    options={GenderOptions}
                    getText={(v) => {
                        return GenderOptionsMap[v];
                    }}
                    onChange={(v) => {
                        this.onCCMChange([{ value: v, path: "PersonalDetails.Gender" }]);
                    }}
                    selected={data.PersonalDetails?.Gender == Gender.Female ? GenderOptions[1] : GenderOptions[0]}
                /> */}
                {hasClientPortalAccess(this.state.roleSelected) && (
                    <RadiosEditor
                        cssWrapper="rg-inline mb-16"
                        label="Read only access"
                        selected={
                            this.state.clientPortalAccess == null && this.state.hasNewUserAccess == false
                                ? false
                                : this.state.clientPortalAccess
                        }
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        onChange={(v) => {
                            this.setState({ clientPortalAccess: v });
                        }}
                        disabled={this.state.hasNewUserAccess == false}
                        required={"Please select"}
                    />
                )}
                {isDisplay(roleType, "Nationality") && (
                    <Nationality
                        data={this.state.nationalities}
                        onChange={(v) => {
                            this.onNationalityChange(v);
                        }}
                        disableTax={false}
                        onRef={(ref) => this.appendChild(ref)}
                        residencies={this.state.residencies}
                        isPoa={roleType == RoleType.PowerOfAttorney}
                    />
                )}
                {isDisplay(roleType, "Addresses") && (
                    <AddAddresses
                        data={data}
                        onCCMChange={(v) => this.onCCMChange(v)}
                        onRef={(ref) => this.appendChild(ref)}
                        onChange={() => {}}
                        canChooseCountry
                        onCorrespondenceAddressChange={(changes) => {
                            this.onCorrespondenceAddressChange(changes);
                        }}
                    />
                )}
                {isDisplay(roleType, "TaxNationality") && (
                    <TaxDetail
                        data={data}
                        onChange={(v) => {}}
                        disableHeader={true}
                        onRef={(ref) => this.appendChild(ref)}
                        onCCMChange={(changes) => {
                            this.onCCMChange(changes);
                        }}
                        disableWhenFullClient={false}
                        existingCustomer={this.props.existingCustomer}
                    />
                )}
                {isDisplay(roleType, "Address") && (
                    <AddAddress
                        label={roleType == RoleType.Employer ? "Business address" : "Residential address"}
                        onAddressChange={(v) => this.props.onChange({ Address: v })}
                        address={data.AddressDetails?.find(
                            (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                        )}
                        index={
                            data.AddressDetails?.length == 0
                                ? 0
                                : !this.hasResident()
                                ? 1
                                : data.AddressDetails?.findIndex(
                                      (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                                  )
                        }
                        canChooseCountry
                        onCCMChange={(changes) => {
                            this.onCCMChange(changes);
                        }}
                        addressType={PhysicalAddressType.Residential}
                        addressList={data.AddressDetails}
                        resetUseAddressForCorrespondence={() => this.resetUseAddressForCorrespondence()}
                        onRef={(ref) => this.appendChild(ref)}
                        onChange={() => {}}
                        data={null}
                        disabled={false}
                    />
                )}

                {isDisplay(roleType, "Phone") && (
                    <PhoneNumberDetails
                        data={data.PhoneNumberDetails}
                        onChange={(val) => {
                            this.onCCMChange([{ path: "PhoneNumberDetails", value: val }]);
                        }}
                        disabled={false}
                        onRef={() => {}}
                    />
                )}
                {roleType == RoleType.ControllingPerson && (
                    <SelectEditor
                        cssWrapper="control-size-600"
                        label={"Type of controlling person"}
                        options={ControllingPersonTypeArray}
                        getText={(o) => ControllingPersonTypeMap[o]}
                        onChange={(v) => this.setState({ controllingPersonType: v })}
                        required={
                            (data?.CustomerTaxResidencyDetails || []).filter(
                                (ele) => ele.Country != CountryCode.GBR && ele.IsTaxResident
                            ).length > 0
                                ? "Please select"
                                : ""
                        }
                        placeholder="Please select"
                    />
                )}
            </>
        );
    }

    private renderRoleOptions() {
        const { availableRoleTypes } = this.state;
        return (
            <>
                <SelectEditor
                    options={this.getRoleDropDown(availableRoleTypes)}
                    cssWrapper="control-size-430"
                    label="Role"
                    getText={(v) => roleTypeMap[v]}
                    selected={this.state.roleSelected?.RoleType}
                    onChange={(v) => {
                        const accountRole = availableRoleTypes?.find((e) => e?.RoleType == v);
                        this.setState({
                            roleSelected: accountRole,
                            isCreateNewCustomer: null,
                            clientPortalAccess: null,
                            customerSelected: null,
                        });
                    }}
                    required={"Please select"}
                    placeholder={"Please select"}
                />
                {this.state.roleSelected && (
                    <RadiosEditor
                        cssWrapper="rg-inline mb-16"
                        label="Add new/existing customer"
                        options={
                            this.state.roleSelected?.CustomerCategory == AccountRoleActorCategory.Associate
                                ? [true]
                                : [true, false]
                        }
                        getText={(e) => (e ? "New" : "Existing")}
                        onChange={(v) => {
                            if (v) {
                                const newCustomer = {
                                    PersonalDetails: {},
                                    AddressDetails: [],
                                    EmploymentDetails: {},
                                    EmailAddressDetails: [],
                                    PhoneNumberDetails: [],
                                    ContactPreferenceDetail: {},
                                    CustomerTaxResidencyDetails: [],
                                };
                                let initArray = [];
                                if (this.state.roleSelected?.RoleType == RoleType.ControllingPerson) {
                                    initArray = FullClientDetailHelper.initTaxModel(initArray, newCustomer);
                                }
                                this.setState(
                                    {
                                        isCreateNewCustomer: v,
                                        clientPortalAccess: null,
                                        customerSelected: newCustomer,
                                    },
                                    () => this.onCCMChange(initArray)
                                );
                            } else {
                                this.setState({
                                    isCreateNewCustomer: v,
                                    clientPortalAccess: null,
                                    customerSelected: null,
                                });
                                this.getInterrestedParty();
                            }
                        }}
                        selected={this.state.isCreateNewCustomer}
                        required={"Please select"}
                    />
                )}
                {this.state.isCreateNewCustomer == false && this.renderCustomerSearch()}
                {this.state.customerSelected && this.renderClientDetails()}
            </>
        );
    }

    private onNationalityChange(changes: CustomerTaxResidencyModel[]) {
        this.setState({ nationalities: changes }, this.updateCustomerTaxData);
    }

    private updateCustomerTaxData() {
        const ctdChanges = [];
        this.state.nationalities
            .filter((nationality) => {
                return nationality.Country;
            })
            .forEach((nationality) => {
                const existingResidencyIndex = ctdChanges.findIndex((residency) => {
                    return nationality.Country === residency.Country;
                });
                if (existingResidencyIndex > -1) {
                    ctdChanges[existingResidencyIndex] = { ...ctdChanges[existingResidencyIndex], ...nationality };
                } else {
                    ctdChanges.push(nationality);
                }
            });

        this.onCCMChange([{ value: ctdChanges, path: "CustomerTaxResidencyDetails" }]);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        const { selectedAccounts, availableAccounts } = this.state;
        const actorId = getQueryParameters()["ipid"];

        if (Number(actorId) > 0) {
            return <>{this.state.customerSelected && this.renderClientDetails()}</>;
        } else {
            const options = [];
            availableAccounts.forEach((account) => {
                options.push({
                    label: account.AccountName + " " + account.HeadClAccountId,
                    value: selectedAccounts.includes(account),
                    disabled: false,
                    onChange: (v) => {
                        let accounts = selectedAccounts;
                        if (v) {
                            const updatedAccountsList = accounts.concat([account]);
                            this.setState({ selectedAccounts: updatedAccountsList });
                            this.getAvailableRoleTypes(
                                updatedAccountsList.map((x) => x?.InvestorType),
                                updatedAccountsList.map((x) => x?.HierarchyId)
                            );
                        } else {
                            accounts = accounts.filter((x) => x != account);
                            this.setState({ selectedAccounts: accounts });
                            this.getAvailableRoleTypes(
                                accounts.map((x) => x?.InvestorType),
                                accounts.map((x) => x?.HierarchyId)
                            );
                        }
                    },
                });
            });
            return (
                <>
                    <h2>{InterestedPartySteppers.clientDetails}</h2>

                    {CommonHelper.isNullOrEmpty(options) && selectedAccounts.length == 0 ? (
                        <span>No available accounts</span>
                    ) : (
                        <CheckboxGroup type="block" options={options} />
                    )}

                    {!CommonHelper.isNullOrEmpty(selectedAccounts) && this.renderRoleOptions()}
                </>
            );
        }
    }
}
